import React from "react";
import PaymentBatchRouter from './Batch/Router';
export { getFields } from './Batch/Router';

export default function PaymentBatchApplicationRouter(props){
    return <PaymentBatchRouter {...props}/>;
}